import { render, staticRenderFns } from "./LandingComponentSpacer.vue?vue&type=template&id=19bfb902&scoped=true"
import script from "./LandingComponentSpacer.vue?vue&type=script&lang=js"
export * from "./LandingComponentSpacer.vue?vue&type=script&lang=js"
import style0 from "./LandingComponentSpacer.vue?vue&type=style&index=0&id=19bfb902&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bfb902",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19bfb902')) {
      api.createRecord('19bfb902', component.options)
    } else {
      api.reload('19bfb902', component.options)
    }
    module.hot.accept("./LandingComponentSpacer.vue?vue&type=template&id=19bfb902&scoped=true", function () {
      api.rerender('19bfb902', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Landing/components/LandingComponentSpacer.vue"
export default component.exports